import { useState, 
         useEffect   }           from "react";
import { useNavigate }           from "react-router-dom";
import Button                    from "components/Button/button";
import MainStyle                 from "components/UI/main.module.scss";
import logo                      from "assets/logo-header.png";
import { GetLabel             }  from "Utilities/utils";

let appLang = null;

export const NotFound = () => {
  const navigate = useNavigate();
  return (
        <div className={[MainStyle.answerpage_cover_404].join(" ")}>
          <div className={[MainStyle.page_cover_404_dialog].join(" ")}>
            <div className={MainStyle.page_cover_404_content}>
              <div className={[MainStyle.page_cover_404_header, MainStyle.text_center].join(" ")}>
                <span className={[MainStyle.fs_3, MainStyle.mx_2, MainStyle.text_dark].join(" ")}>  
                  {GetLabel(appLang, 167)}
                </span>
              </div>
              {
                /*
                <div className={MainStyle.page_cover_404_body}>
                  <div className={MainStyle.page_cover_404_scene}>
                    <div className={MainStyle.cube_scene}>
                      <div className={[MainStyle.cube_face, MainStyle.cube_front].join(" ")}><img src={logo} style={{width: '180px', height: '34px'}} alt="Logo ISE"></img></div>
                      <div className={[MainStyle.cube_face, MainStyle.cube_back].join(" ")}><img src={logo} style={{width: '180px', height: '34px'}} alt="Logo ISE"></img></div>
                      <div className={[MainStyle.cube_face, MainStyle.cube_right].join(" ")}></div>
                      <div className={[MainStyle.cube_face, MainStyle.cube_left].join(" ")}></div>
                      <div className={[MainStyle.cube_face, MainStyle.cube_top].join(" ")}></div>
                      <div className={[MainStyle.cube_face, MainStyle.cube_bottom].join(" ")}></div>
                    </div>
                  </div>
                </div>
                */
              }
              <div className={MainStyle.page_cover_404_footer}>
                <div className={MainStyle.mt_5}>
                  <Button                  
                    onClick={() => { navigate("/"); }}
                    className={[MainStyle.btn_blue, 
                                MainStyle.rounded_4, 
                                MainStyle.border, 
                                MainStyle.shadow, 
                                MainStyle.fs_5,
                                MainStyle.text_white,
                                MainStyle.p_3].join(" ")}
                  >
                            <span className={[MainStyle.py_5, MainStyle.m_3].join(" ")}>
                                {GetLabel(appLang, 168)}
                            </span>
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
};